import { bankMovementsHistory as getAllCashFlowHistory } from "@/api/financialEntity";

export default {
    state: {
        chartParams: {},
        cashFlowData: [],
    },
    mutations: {
        SET_CASH_FLOW_DATA: (state, payload) => {
            state.cashFlowData = payload;
        },
        SET_CHART_PARAMS: (state, payload) => {
            state.charParams = payload;
        },
    },
    actions: {
        getCashFlowHistory({ state, commit }, payload) {
            commit("SET_CHART_PARAMS", payload);
            return new Promise((resolve, reject) => {
                getAllCashFlowHistory({ params: state.charParams })
                    .then((response) => {
                        commit("SET_CASH_FLOW_DATA", response.data);
                        resolve(true);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
    },
    getters: {},
    namespaced: true,
};
